export const useOwnerRegisterStore = defineStore('ownerRegisterStore', () => {
    const formOneData: any = ref({
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        contact: null,
        password: null,
        password_confirmation: null,
        agree: null,
    });

    const formTwoData: any = ref({
        name: null,
        address1: null,
        region_id: null,
        city_id: null,
        barangay_id: null,
        categories: null,
        // position: null,
        contact: null,
        planType: {
            label: "Basic Plan (P0/month)",
            value: "Basic"
        },
        // paymentMethod: null,
        card_number: null,
        exp_month: null,
        exp_year: null,
        card_holder_name: null,
        cvc: null,
    })

    const storeRedirectUrl: any = ref(null)

    // Setting for Form One
    const $setFormOneData = (data: any) => {
        formOneData.value = data;
    }

    // Setting for Form Two
    const $setFormTwoData = (data: any) => {
        console.log('in store setting form to data', data)
        formTwoData.value = data;
        console.log(data);
    }

    const $getFormTwoData = () => {
        return formTwoData.value;
    }

    const $setFormDashboardUrlData = (data: any) => {
        storeRedirectUrl.value = data;
    }

    const $clearForms = () => {
        formOneData.value = null;
        formTwoData.value = null;
    }

    return {
        formOneData,
        formTwoData,
        storeRedirectUrl,
        $setFormDashboardUrlData,
        $setFormOneData,
        $setFormTwoData,
        $getFormTwoData,
        $clearForms
    }
  })